import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
import commonModals from "../../vue/CommonComponents/CommonModals";
import { useAppBanner } from "./useAppBanner";
//@ts-ignore
import PublicUserMenu from "@vueEntry/PublicUserMenu.vue";
//@ts-ignore
import { useFirebaseMessaging } from "@wkComposables/useFirebaseMessaging";
import { createApp, defineAsyncComponent } from "vue";
import { mapState, mapActions, createPinia } from "pinia";
import { useLoggedUserStore, usePublicUserMenuStore, useModalStore, useBaseStore
//@ts-ignore
} from "@store/index";
//@ts-ignore
import LanguageIcons from "@vueEntry/CommonComponents/LanguageIcons";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
export default (options => {
  var _a;
  var app = createApp({
    name: options.name,
    components: Object.assign(Object.assign(Object.assign({
      PublicUserMenu,
      //@ts-ignore
      "async-dropdown": defineAsyncComponent(() => import("@vueEntry/UIKitComponents/BaseDropDown.vue"))
    }, LanguageIcons), commonModals), options.components),
    setup() {
      var {
        isAppBannerVisible
      } = useAppBanner();
      var {
        isLarge
      } = useBreakpoints();
      var {
        showFirebaseSnackbar,
        snackbarTitle,
        snackbarBody,
        snackbarIcon,
        handleOnForegroundNotificationClick
      } = useFirebaseMessaging();
      return {
        isLarge,
        isAppBannerVisible,
        //useFirebaseMessaging
        showFirebaseSnackbar,
        snackbarTitle,
        snackbarBody,
        snackbarIcon,
        handleOnForegroundNotificationClick
      };
    },
    computed: Object.assign(Object.assign(Object.assign({}, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter", "mailConfirmed", "name"])), mapState(useModalStore, ["showModal"])),
    created() {
      this.initPublicUserMenu().then(() => {
        options.onMounted && options.onMounted;
      });
    },
    mounted() {
      options.onMounted && options.onMounted();
    },
    methods: Object.assign(Object.assign(Object.assign({}, (_a = options.methods) !== null && _a !== void 0 ? _a : {}), mapActions(useModalStore, ["setShowModal"])), mapActions(useBaseStore, ["logout", "initPublicUserMenu"]))
  });
  app.use(createPinia());
  app.mount(options.el);
  return app;
});